import Vue from 'vue'
import VueI18n from 'vue-i18n'

import elementEn from 'element-ui/lib/locale/lang/en'
import elementZh from 'element-ui/lib/locale/lang/zh-CN'

import en from './en/en'
import zh from './zh-CN/zh-CN'

Vue.use(VueI18n);

const messages = {
  "en": {
    ...en,
    ...elementEn
  },
  "zh": {
    ...zh,
    ...elementZh
  }
}

const i18n = new VueI18n({
  locale: 'en',
  messages,
  silentTranslationWarn: true //去除国际化警告
})

export default i18n



// WEBPACK FOOTER //
// ./src/lang/index.js